var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.604023 18.6947C0.435416 18.9134 0.476018 19.2274 0.69471 19.396C0.913402 19.5646 1.22737 19.524 1.39598 19.3053L0.604023 18.6947ZM6.75481 11.5357L7.10345 11.1773L6.70135 10.7862L6.35883 11.2304L6.75481 11.5357ZM10.5913 15.2679L10.2427 15.6263L10.6492 16.0217L10.9906 15.5688L10.5913 15.2679ZM1.39598 19.3053L7.15078 11.841L6.35883 11.2304L0.604023 18.6947L1.39598 19.3053ZM6.40616 11.8941L10.2427 15.6263L10.94 14.9095L7.10345 11.1773L6.40616 11.8941ZM10.9906 15.5688L18.0243 6.23848L17.2257 5.63652L10.1921 14.9669L10.9906 15.5688Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.382 4.50325C14.382 5.83066 13.8076 7.02393 12.8939 7.84812C13.2941 7.92613 13.6821 8.03853 14.0545 8.18213L10.4177 13.0064L7.80074 10.4606L6.59443 9.28715L5.56687 10.6199L1 16.5434V14.6595C1 11.2076 3.52032 8.3443 6.82119 7.80945C5.9321 6.98683 5.37547 5.81004 5.37547 4.50325C5.37547 2.01617 7.39164 0 9.87871 0C12.3658 0 14.382 2.01617 14.382 4.50325ZM3.45675 18.2702H18.4983V14.6595C18.4983 12.7902 17.7592 11.0935 16.5574 9.84571L11.7891 16.1709L10.765 17.5295L9.54541 16.3431L6.91518 13.7845L3.45675 18.2702Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 3.83043L18.8086 7.66826L15.4861 5.74742L18.8108 3.83043Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActivity);
export default __webpack_public_path__ + "static/media/userActivity.a6407c98baf27d4242c282001dc805ba.svg";
export { ForwardRef as ReactComponent };